let countryCode;
async function getUserLocation() {
  const response = await fetch(
    window.Shopify.routes.root
      + 'browsing_context_suggestions.json'
      + '?country[enabled]=true'
      + `&country[exclude]=${window.Shopify.country}`
      + '&language[enabled]=true'
      + `&language[exclude]=${window.Shopify.language}`
  );
  const data = await response.json();
  countryCode = data?.detected_values?.country?.handle;
  return data?.detected_values?.country?.name;
}

async function getCountryCode() {
  if (!countryCode) {
    await getUserLocation();
  }

  return countryCode ?? 'US';
}

function getLocalizationData() {
  return new Promise((resolve) => {
    if (window.localizationData) {
      resolve(window.localizationData);
      return;
    }

    document.addEventListener('localization-data-ready', function() {
      resolve(window.localizationData);
    })
  });
}

function changeCountry(countryCode) {
  const localizationController = document.querySelector('localization-controller');

  if (localizationController) {
    localizationController.changeCountry(countryCode);
  }
}

class ShippingAvailability extends HTMLElement {
  constructor() {
    super();
    this.shippingMessageElement = this.querySelector('.shipping-message-country');
    this.availableCountriesElement = document.getElementById('localization-available-countries');
    this.supportedCountries = JSON.parse(this.availableCountriesElement.textContent);
    this.freeShippingMsg = document.querySelector('.free-shipping-msg');
  }

  async connectedCallback() {
    await this.checkShippingAvailability();
  }

  async checkShippingAvailability() {
    const userCountry = await getUserLocation(); // Use global getUserLocation function

    // Check if the user's country is in the supported countries
    if (!this.supportedCountries.includes(userCountry)) {
      // Check if the shipping message element exists within the custom element
      if (this.shippingMessageElement) {
        // Display message if the country is not supported
        this.shippingMessageElement.innerHTML = userCountry;
      }
      this.style.display = 'block';
      if(this.freeShippingMsg) this.freeShippingMsg.classList.add('hidden');
    } else {
      this.style.display = 'none';
      if(this.freeShippingMsg) this.freeShippingMsg.classList.remove('hidden');
    }
  }
}

customElements.define('shipping-availability', ShippingAvailability);